export default __webpack_public_path__ + "static/media/resume2023.331a7380.jpg";